var dfs = require('./dfs')

module.exports = postorder

function postorder (g, vs) {
  return dfs(g, vs, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./~/graphlibrary/lib/alg/postorder.js
// module id = 1622
// module chunks = 0